import React from 'react';
import Styled from 'styled-components';
import Icon from '@components/Icon';
import { Trans } from '@lingui/react';
import { Body, Footer } from '../base';
import Button from '@components/buttons';

const Wrapper = Styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
`;

const Title = Styled.p`
  font-size: 18px;
  font-weight: 600;
  margin: 0;
`;

const Text = Styled.p`
  font-size: 16px;
  margin: 15px 0 0;
`;

const PaymentPendingMessage = ({ onClose }) => {
  return (
    <>
      <Body pb={40}>
        <Wrapper data-testid="PaymentPendingMessage">
          <Icon
            name="ygb-icon-checkmark"
            fontSize="24px"
            color="white"
            style={{
              lineHeight: 1,
              backgroundColor: '#FFA351',
              borderRadius: '50%',
              padding: '50px',
              margin: '0 auto 20px',
            }}
          />
          <Title>
            <Trans id="payment_subscription_pending.modal.title" />
          </Title>
          <Text>
            <Trans id="payment_subscription_pending.modal.body" />
          </Text>
        </Wrapper>
      </Body>
      <Footer>
        <Button onClick={onClose}>
          <Trans id="metadata.payment.success.continue_button" />
        </Button>
      </Footer>
    </>
  );
};

export default PaymentPendingMessage;
